import { DIMixins, DIValidators, EFinancasModulos } from "@/core/@types/types";
import { diContainer } from "@/di";
import { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360Validator } from "@/core/validators/F360Validator";

export interface IConfigProfile {
  isLight: boolean;
  isFit: boolean;
  hideModulos: boolean;
  modulo: keyof typeof EFinancasModulos;
}

export function useRegraModulosCielo(): IConfigProfile | undefined {
  const isCielo = diContainer
    .get<IF360Validator>(DIValidators.CIELO)
    .handleValidation();

  const profile = diContainer
    .get<IUserProfileStorageMixin>(DIMixins.USER_PROFILE_STORAGE)
    .handleGetUserProfile();

  if (!isCielo) {
    return;
  }

  if (!profile) {
    return;
  }

  const moduloValor = profile?.Modulo || 0;

  const configProfile: IConfigProfile = {
    isLight: false,
    isFit: false,
    hideModulos: false,
    modulo: EFinancasModulos.COMPLETO
  };

  switch (Number(moduloValor)) {
    case 0:
      configProfile.modulo = EFinancasModulos.COMPLETO;
      break;
    case 1:
      configProfile.hideModulos = false;
      configProfile.modulo = EFinancasModulos.COMPLETO;
      break;
    case 2:
      configProfile.hideModulos = true;
      configProfile.isFit = true;
      configProfile.modulo = EFinancasModulos.CIELO_FIT;
      break;
    case 3:
      configProfile.hideModulos = true;
      configProfile.isLight = true;
      configProfile.modulo = EFinancasModulos.CIELO_LIGHT;
      break;
    default:
      configProfile.hideModulos = false;
      configProfile.modulo = EFinancasModulos.COMPLETO;
      break;
  }

  return configProfile;
}
